const generateUUID = (): string => crypto.randomUUID?.() ?? rnd();

/**
 *	When running the iOS simulator in hot-reload mode we don't have access to crypto.randomUUID,
 *	but we can still use crypto.getRandomValues for cryptographically secure randomness.
 */
const rnd = () => {
	const array = new Uint32Array(4);
	crypto.getRandomValues(array);

	return Array.from(array, (num) => num.toString(36)).join('');
};

export default generateUUID;
